import React from "react";
import { StyledTextBox, StyledTextBoxGrid } from "./TextBoxGrid.styled";
import { CaptionsTyp } from "../Typography/Typography";
import { theme } from "../../constants/StyledComponents";
import { TextAreaBox } from "../TextAreaBox/TextAreaBox";

interface TextBoxItem {
  label: string;
  text?: string | React.ReactNode | null;
  error?: boolean;
}

export const TextBox = ({ label, text, error }: TextBoxItem) => {
  return (
    <StyledTextBox>
      <div className="label">
        <CaptionsTyp color={theme.colors.grey_2}>{label}</CaptionsTyp>
      </div>
      <div className="text">
        <TextAreaBox text={text} error={error} noTranslate />
      </div>
    </StyledTextBox>
  );
};

interface TextBoxGridProps {
  items: TextBoxItem[];
  numCol: number;
}

export const TextBoxGrid = ({ items, numCol }: TextBoxGridProps) => {
  return (
    <StyledTextBoxGrid $numCol={numCol}>
      {items.map((item, index) => (
        <TextBox
          key={`${item.label}${index}`}
          label={item.label}
          text={item.text}
        />
      ))}
    </StyledTextBoxGrid>
  );
};
